<div #container (keydown)="handleKeyDown($event)" tabindex="0" class="wrapper">
  <rt-redactor-inserts-dropdown-header
    [hasBackAction]="hasBackAction"
    [hasSearch]="state.schedules.length > 5"
    [searchQuery]="state.searchQuery"
    [hasSettings]="!!state.schedules.length"
    [label]="'app.redactor_inserts.scheduler.dropdown.heading' | translate"
    [searchPlaceholder]="'app.common.placeholders.search.scheduler_links.other' | translate"
    (searchQueryChange)="onSearchQueryChange($event)"
    (goBack)="goBack()"
    (goToSettings)="goToSettings('/settings/scheduler')"
    (focusChanges)="onFocusChanges($event)"
    (closeDropdown)="closeDropdown.emit()"
  >
  </rt-redactor-inserts-dropdown-header>
  @if (!state.loaded) {
    <rt-spinner padding></rt-spinner>
  }
  @if (state.scheduleGroups.length > 0 && state.loaded) {
    <div class="group-container">
      @for (
        scheduleGroup of state.scheduleGroups;
        track groupsTrackByFn($index, scheduleGroup);
        let lastGroup = $last
      ) {
        <div>
          <rt-dropdown-header [isSubheading]="true">
            {{ scheduleGroup.groupName }}
          </rt-dropdown-header>
          @for (
            schedule of scheduleGroup.groupedSchedules;
            track trackBySchedule(index, schedule);
            let index = $index;
            let lastItem = $last
          ) {
            <rt-dropdown-item
              #eleRef
              [highlighted]="state.selectedId === schedule.id"
              [attr.data-id]="schedule.id"
              [noDivider]="lastItem && lastGroup"
              (click)="onScheduleSelect(schedule)"
            >
              <div layout-horizontal>
                <div layout-flex-1-0 layout-vertical>
                  <rt-truncate
                    [class.with-badge]="schedule.assignAnyInterviewer"
                    class="schedule-name"
                  >
                    <b layout-flex-1-1>{{ schedule.name }}</b>
                  </rt-truncate>
                  <div class="admins" layout layout-space-between layout-align-items-center>
                    <rt-admins-avatars
                      [admins]="schedule.admins"
                      [avatarShape]="'oval'"
                      [avatarSize]="'small'"
                      [limit]="3"
                      [stacked]="true"
                      [hasStopPropagation]="false"
                      (click)="onScheduleSelect(schedule)"
                      margin-top-small-x
                    >
                    </rt-admins-avatars>
                  </div>
                </div>
              </div>
              <div suffix class="item-suffix">
                @if (!isProsemirror) {
                  <div class="icon-wrapper">
                    <rt-icon-button
                      (click)="editSchedulerLink($event, schedule.id)"
                      variant="plain"
                      iconName="edit-underline"
                      shape="square"
                    >
                    </rt-icon-button>
                  </div>
                }
                @if (schedule.assignAnyInterviewer) {
                  <div class="badge-wrapper">
                    <rt-badge
                      [text]="'app.settings.scheduler.1st_available' | translate"
                      color="counter-light"
                    ></rt-badge>
                  </div>
                }
              </div>
            </rt-dropdown-item>
          }
        </div>
      }
    </div>
  }

  @if (state.scheduleGroups.length === 0 && !state.searchQuery.length && state.loaded) {
    <rt-empty-state
      [title]="'app.redactor_inserts.scheduler.dropdown.empty_state_title' | translate"
      [desc]="'app.redactor_inserts.scheduler.dropdown.empty_state_desc' | translate"
      variant="small"
      class="empty-state"
      padding-lr
    >
      @if (!isProsemirror) {
        <div layout-vertical layout-justify-center>
          <rt-button
            (click)="createSchedulerLink($event)"
            variant="primary"
            margin-lr
            margin-bottom-small-x
            layout-flex-0-0
          >
            {{ 'app.redactor_inserts.scheduler.dropdown.create_link_now' | translate }}
          </rt-button>
        </div>
      }
    </rt-empty-state>
  }

  @if (state.scheduleGroups.length === 0 && state.searchQuery.length && state.loaded) {
    <rt-empty-state
      [title]="'app.redactor_inserts.scheduler.dropdown.no_filtered_title' | translate"
      [desc]="'app.redactor_inserts.scheduler.dropdown.no_filtered_desc' | translate"
      variant="small"
      class="empty-state"
      padding-lr
    >
    </rt-empty-state>
  }

  @if (state.schedules.length && state.loaded && !isProsemirror) {
    <rt-divider></rt-divider>
    <rt-dropdown-item (click)="createSchedulerLink($event)" [isCreateAction]="true">
      <rt-icon prefix name="add-circle-outline"></rt-icon>
      {{ 'app.redactor_inserts.scheduler.dropdown.create_new_one' | translate }}
    </rt-dropdown-item>
  }
</div>
